import { DeleteGroupsRequestBody } from "@syla/shared/types/requests/DeleteGroupsRequestBody";
import axios from "axios";
import { OrderFilterSetting } from "../../types/order/orderQuery";
import { filterToFilterParams } from "./filterToFilterParams";

export async function deleteOrders({
  accountId,
  orders,
  filter,
}: {
  accountId: string;
  orders?: string[];
  filter?: OrderFilterSetting;
}): Promise<void> {
  const data: DeleteGroupsRequestBody = {
    ids: orders,
    filter: filter ? filterToFilterParams(filter) : undefined,
  };
  axios.delete(`/accounts/${accountId}/orders`, {
    data,
  });
}
